import styles from './index.module.scss';
import cx from 'classnames';
import { Typography } from '@navi/web-ui/lib/primitives';
import { ILeftPanel } from './types';
import { DATE_QUERY_PARAMS, FilterKeys } from './constants';
import { _map } from '@cp/src/utils/commonUtils';

const LeftPanel = (props: ILeftPanel) => {
  const { filterSchemaMap, filterSchema, selectedFilter, selectedOptions, handleFilterChange } =
    props;

  const ALWAYS_SHOW_FILTERS = ['allocatedFieldAgent', 'states'];

  return (
    <div>
      {filterSchemaMap?.map(filterKey => {
        if (DATE_QUERY_PARAMS.includes(filterKey as FilterKeys)) return null;
        const { label, options } = filterSchema?.[filterKey] || {};
        if (!options?.length && !ALWAYS_SHOW_FILTERS.includes(filterKey)) return null;

        const isNestedFilter = filterSchema?.[filterKey]?.nestedFilter;
        let selectedFilterCount = 0;

        if (isNestedFilter) {
          _map(selectedOptions?.[filterKey] || {}, nestedFilterKey => {
            if (selectedOptions?.[filterKey]?.[nestedFilterKey]?.length) {
              selectedFilterCount += 1;
            }
          });
        } else {
          selectedFilterCount = selectedOptions?.[filterKey]?.length;
        }

        return (
          <div
            className={styles.filterSection}
            onClick={() => handleFilterChange(filterKey)}
            key={filterKey}
          >
            <Typography
              variant="h4"
              className={cx(
                { [styles.selectedFilter]: selectedFilter === filterKey },
                styles.filter
              )}
            >
              {label}
            </Typography>
            {selectedFilterCount ? (
              <Typography variant="h6" className={styles.count}>
                {selectedFilterCount}
              </Typography>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default LeftPanel;
